export default function FakeTable() {
  const data = [
    {
      datetime: "19-Jun-2021 12:17:17",
      temp: "24.7"  }
  ,
    {
      datetime: "19-Jun-2021 12:47:17",
      temp: "24.6"
    },
    {
      datetime: "19-Jun-2021 13:17:17",
      temp: "24.8"
    },
    {
      datetime: "19-Jun-2021 13:47:17",
      temp: "25.0"
    },
    {
      datetime: "19-Jun-2021 14:17:17",
      temp: "25.1"
    },
    {
      datetime: "19-Jun-2021 14:47:17",
      temp: "25.4"
    },
    {
      datetime: "...",
      temp: "..."
    }];


  return (
    <div>
       {/* style={{ margin: "0 10px 0 0" }} */}
      <table>
        <thead bgcolor="blue">
          <tr>
            <th>Date & Time</th>
            <th>Temperature (℃)</th>
          </tr>
        </thead>
        <tbody>
          {
            data.map((row, idx) => (
              <tr key={idx}>
                <td>{ row.datetime }</td>
                <td>{ row.temp }</td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>
  );
}

